import { render, staticRenderFns } from "./PlayerProcessedVideo.vue?vue&type=template&id=bb28dc36&scoped=true&"
import script from "./PlayerProcessedVideo.vue?vue&type=script&lang=js&"
export * from "./PlayerProcessedVideo.vue?vue&type=script&lang=js&"
import style0 from "./PlayerProcessedVideo.vue?vue&type=style&index=0&id=bb28dc36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb28dc36",
  null
  
)

export default component.exports